import React, { useState, useEffect } from 'react'
import { Row } from 'reactstrap'
import { Button, DropDown, IconOptions } from '@Knowledge-OTP/znk-ui-components'
import Skeleton from 'react-loading-skeleton'
// import useTranslation from '../../../i18n/useTranslation'
import NewTagModal from './Modal/newTag'
import useGetAllTags from './Model/useGetAllTags'
import { getTagTypeLabel } from '../Utils/tagTypeLabel'
import TagBadgeComponent from '../../Student/modal/InfoStudent/TagsBadge/Components/tagBadgeComponent'

const TagsView = () => {
    const [isOpenNewTagModal, setIsOpenNewTagModal] = useState(false)
    const [tagToEdit, setTagToEdit] = useState(null)
    //eslint-disable-next-line
    const [getAllTags, { data: dataTags, loading: loadingTags, error: errorTags, refetch: refetchTags }] = useGetAllTags()

    useEffect(() => {
        getAllTags()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // const hanledSearch = (value) => {
    //     setTxtSearch(value)
    // }
    return (
        <div className='d-flex flex-column'>
            <Row className='d-flex flex-column mx-0'>
                <div className='d-flex justify-content-end'>
                    <span>
                        {/* <InputSearch
                            placeholder='Search'
                            className='m-0 p-3 h-25 trans flex-nowrap'
                            addOnComponent={<IconSearch size={18} className='text-gray' />}
                            value={txtSearch}
                            onChange={(value) => { hanledSearch(value) }}
                        /> */}
                    </span>
                    <span><Button label='Add Tag' className='btn-table' color='primary'
                        onClick={() => {
                            setTagToEdit(null)
                            setIsOpenNewTagModal(true)
                        }}
                    /></span>

                </div>
            </Row>
            <Row className='d-flex flex-column mx-0 mt-4'>
                {
                    loadingTags
                        ? <Skeleton height={25} count={5} className='my-2' />
                        : (errorTags
                            ?
                            <div className='alert alert-danger'>Error en la petición</div>
                            : dataTags?.allTags.docs.map((item) => {
                                let options = [{
                                    component:
                                        <span
                                            className='p-3'
                                            onClick={() => {
                                                setTagToEdit(item)
                                                setIsOpenNewTagModal(true)
                                            }}
                                        >Edit Tag</span>
                                }]

                                return (
                                    <div
                                        key={item.id}
                                        className={`znk-invoice-row draft}`}
                                        style={{
                                            paddingTop: 0, paddingBottom: 0, maxHeight: '30px',
                                        }}
                                    >
                                        <TagBadgeComponent tag={item} />
                                        <span className='text-color text-gray'>{getTagTypeLabel(item?.type)}</span>
                                        <span className='text-color text-gray'>{item?.isActive ? 'Active' : 'Inactive'}</span>
                                        {/* <span className='text-color text-gray'>{moment(item.createdAt).format('MMMM do, hh:mm')}</span>
                                            <span className='text-color text-gray'>{moment(item.updatedAt).format('MMMM do, hh:mm')}</span> */}
                                        <span className='flex-grow-0'>
                                            <div className='znk-table-dropdown dropdown-menu-width-content pr-0'>
                                                <DropDown
                                                    direction='down'
                                                    fixedWidth
                                                    hoverEnabled={false}
                                                    options={options}
                                                >
                                                    <div className='d-flex flex-row'>
                                                        <IconOptions style={{ transform: 'rotate(90deg)', marginRight: 10 }} color='rgba(37, 64, 80, 0.6)' />
                                                    </div>
                                                </DropDown>
                                            </div>
                                        </span>
                                    </div>
                                )
                            })
                        )
                }
            </Row>
            <NewTagModal isOpen={isOpenNewTagModal} setIsOpen={setIsOpenNewTagModal} refetchList={refetchTags} toggle={null} tagToEdit={tagToEdit} />
        </div>
    )
}

export default TagsView
